<template>
  <BlocoFormularioCadastro voltar="/profissional/bloqueio" @salvar="salvar()">
    <template #form>
      <div
        :class="{
          'panel-primary': !v$.bloqueio.$error,
          'panel-danger': v$.bloqueio.$error,
        }"
        class="panel"
      >
        <div class="panel-heading"> Bloqueio </div>
        <div class="panel-body">
          <div class="row">
            <div
              v-if="usuario.perfil !== 'Profissional'"
              class="col-xs-12 col-sm-6 col-md-3 col-lg-3"
            >
              <div
                :class="{ 'has-error': v$.bloqueio.profissional._id.$error }"
                class="form-group"
              >
                <label for="profissional">Profissional <sup>(1)</sup></label>
                <BuscarSelecionar
                  :lista="profissionais"
                  :selecionado="bloqueio.profissional"
                  :minimo="0"
                  @selecionar="selecionarProfissional"
                  @limpar="limparProfissional"
                  @recuperar="recuperarProfissionais"
                />
              </div>
            </div>
            <div
              v-if="usuario.perfil === 'Profissional'"
              class="col-xs-12 col-sm-6 col-md-3 col-lg-3"
            >
              <div
                :class="{ 'has-error': v$.bloqueio.profissional._id.$error }"
                class="form-group"
              >
                <label for="profissionalRO">Profissional</label>
                <input
                  id="profissionalRO"
                  v-model="bloqueio.profissional.nome"
                  data-test-id="input-profissionalro"
                  type="text"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
              <div class="form-group">
                <label for="regra">Regra</label>
                <select
                  v-model="bloqueio.regra"
                  data-test-id="select-bloqueio-regra"
                  class="form-control"
                >
                  <option value="1">Apenas um dia</option>
                  <option value="2">Intervalo de datas</option>
                </select>
              </div>
            </div>
            <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
              <div
                :class="{ 'has-error': v$.bloqueio.dataInicio.$error }"
                class="form-group"
              >
                <label for="dataInicio">Data <sup>(1)</sup></label>
                <div id="dataInicio" class="input-group">
                  <input
                    v-model="bloqueio.dataInicio"
                    v-mask="'99/99/9999'"
                    data-test-id="input-bloqueio-datainicio"
                    type="text"
                    class="form-control"
                    placeholder="DD/MM/AAAA"
                  />
                  <div class="input-group-addon">
                    <span
                      type="button"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="fa fa-calendar" />
                    </span>
                    <span class="dropdown-menu">
                      <li>
                        <DatePicker
                          v-model="bloqueio.dataInicio"
                          :today-btn="false"
                          :clear-btn="false"
                          :format="'dd/MM/yyyy'"
                          :close-on-selected="true"
                          :date-parser="dataParser"
                          class="date-picker"
                        />
                      </li>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="bloqueio.regra === '2'"
              class="col-xs-6 col-sm-2 col-md-2 col-lg-2"
            >
              <div class="form-group">
                <label for="dataFim">Termina em</label>
                <div id="dataFim" class="input-group">
                  <input
                    v-model="bloqueio.dataFim"
                    v-mask="'99/99/9999'"
                    data-test-id="input-bloqueio-datafim"
                    type="text"
                    class="form-control"
                    placeholder="DD/MM/AAAA"
                  />
                  <div class="input-group-addon">
                    <span
                      type="button"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="fa fa-calendar" />
                    </span>
                    <span class="dropdown-menu">
                      <li>
                        <DatePicker
                          v-model="bloqueio.dataFim"
                          :today-btn="false"
                          :clear-btn="false"
                          :format="'dd/MM/yyyy'"
                          :close-on-selected="true"
                          :limit-from="bloqueio.dataInicio"
                          :date-parser="dataParser"
                          class="date-picker"
                        />
                      </li>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
              <div class="form-group">
                <label for="horario">Especificar horário?</label>
                <div id="id" class="input-group">
                  <span class="input-group-addon">
                    <input
                      v-model="bloqueio.temHorario"
                      data-test-id="input-bloqueio-temhorario"
                      type="checkbox"
                      @click="limparHorario()"
                    />
                  </span>
                  <input
                    v-mask="'99:99'"
                    data-test-id="input-auto-6"
                    :disabled="!bloqueio.temHorario"
                    :value="bloqueio.horarioInicio"
                    type="text"
                    class="form-control"
                    @input="atualizaHora('horarioInicio', $event.target.value)"
                  />
                  <span class="input-group-addon">até</span>
                  <input
                    v-mask="'99:99'"
                    data-test-id="input-auto-7"
                    :disabled="!bloqueio.temHorario"
                    :value="bloqueio.horarioFim"
                    type="text"
                    class="form-control"
                    @input="atualizaHora('horarioFim', $event.target.value)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
              <div class="form-group">
                <label for="ativo">Situação<sup>(1)</sup></label>
                <select
                  id="ativo"
                  v-model="bloqueio.ativo"
                  data-test-id="select-ativo"
                  class="form-control"
                >
                  <option value="true">Ativo</option>
                  <option value="false">Cancelado</option>
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
              <div
                :class="{ 'has-error': v$.bloqueio.motivo.$error }"
                class="form-group"
              >
                <label>Motivo <sup>(1)</sup></label>
                <select
                  v-model="bloqueio.motivo"
                  data-test-id="select-bloqueio-motivo"
                  class="form-control"
                >
                  <option
                    v-for="motivo in motivos"
                    :key="motivo.valor"
                    :value="motivo.valor"
                  >
                    {{ motivo.valor }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div
                :class="{ 'has-error': v$.bloqueio.observacao.$error }"
                class="form-group"
              >
                <label for="observacao">Observação (2)</label>
                <textarea
                  id="observacao"
                  v-model="bloqueio.observacao"
                  data-test-id="textarea-observacao"
                  class="form-control"
                  rows="3"
                  @input="v$.bloqueio.observacao.$touch()"
                />
                <span v-if="v$.bloqueio.observacao.$dirty">
                  <span
                    v-if="!v$.bloqueio.observacao.required"
                    class="help-block"
                    >Campo obrigatório quando selecionado motivo "Outro".</span
                  >
                  <span
                    v-if="!v$.bloqueio.observacao.maxLength"
                    class="help-block"
                    >Campo deve ter no máximo
                    {{ v$.bloqueio.observacao.$params.maxLength.max }}
                    letras.</span
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>(1) Campos obrigatórios.</p>
      <p>(2) Campo obrigatório quando selecionado motivo "Outro".</p>
    </template>
  </BlocoFormularioCadastro>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { maxLength, required, requiredIf } from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'
import { DatePicker } from 'uiv'

import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import { useMenu } from '@/composables/useMenu'
import { dominioMixin } from '@/mixins/DominioMixin'
import router from '@/router'
import MensagemServico from '@/servicos/MensagemServico'
import ProfissionalBloqueioServico from '@/servicos/ProfissionalBloqueioServico'
import ProfissionalServico from '@/servicos/ProfissionalServico'
import appStore from '@/stores'
moment.locale('pt-br')

const profissionalServico = new ProfissionalServico()
const profissionalBloqueioServico = new ProfissionalBloqueioServico()
const mensagemServico = new MensagemServico()

export default {
  components: {
    DatePicker,
    BuscarSelecionar,
    BlocoFormularioCadastro,
  },
  directives: { mask: AwesomeMask },
  mixins: [dominioMixin],
  setup() {
    useMenu(18)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      profissionais: [],
      motivos: [],
      bloqueio: {
        profissional: {
          _id: '',
          nome: '',
        },
        dataInicio: '',
        dataFim: '',
        horarioInicio: '00:01',
        horarioFim: '23:59',
        motivo: '',
        observacao: '',
        ativo: true,
        regra: 1,
        temHorario: false,
      },
    }
  },
  validations: {
    bloqueio: {
      profissional: { _id: { required } },
      dataInicio: { required },
      motivo: { required },
      observacao: {
        required: requiredIf(function () {
          return this.bloqueio.motivo === 'Outro'
        }),
        maxLength: maxLength(200),
      },
    },
  },
  computed: {
    usuario() {
      return appStore.usuario
    },
  },
  created() {
    this.recuperarValoresDominio('MotivoBloqueio').then((res) => {
      this.motivos = res.valores
    })
    this.recuperarBloqueio()
    this.inicializaParaProfissional()
  },
  methods: {
    inicializaParaProfissional() {
      if (this.usuario.perfil === 'Profissional') {
        profissionalServico
          .recuperarTodos({ email: this.usuario.email })
          .then((result) => {
            if (!result.profissionais.length) {
              mensagemServico.alerta(
                'O usuário logado não tem cadastro profissional no sistema'
              )
            } else if (!this.bloqueio.profissional._id) {
              this.bloqueio.profissional = result.profissionais[0]
            }
          })
      }
    },
    atualizaHora(hora, value) {
      const h = moment(value, 'HH:mm')

      if (value.length === 5 && h.isValid()) {
        this.bloqueio[hora] = value
      }
    },
    limparHorario() {
      this.bloqueio.horarioInicio = '00:01'
      this.bloqueio.horarioFim = '23:59'
    },
    selecionarProfissional(profissional) {
      this.bloqueio.profissional = {
        _id: profissional._id,
        nome: profissional.nome,
      }
    },
    limparProfissional() {
      this.bloqueio.profissional = {}
    },
    recuperarProfissionais(filtro) {
      const data = {
        nome: filtro.palavra,
        skip: (filtro.pagina - 1) * filtro.limite,
        limit: filtro.limite,
        orderBy: filtro.chave,
      }

      profissionalServico.recuperarTodos(data).then((result) => {
        this.profissionais = result.profissionais
      })
    },
    dataParser(value) {
      return moment(value, 'DD/MM/YYYY').toDate().getTime()
    },
    recuperarBloqueio() {
      const bloqueioId = this.$route.params.id
      this.bloqueio.temHorario = false

      if (bloqueioId) {
        profissionalBloqueioServico.recuperar(bloqueioId).then((result) => {
          this.bloqueio._id = bloqueioId
          this.bloqueio.profissional = result.bloqueio.profissional
          this.bloqueio.dataInicio = moment(result.bloqueio.dataInicio).format(
            'DD/MM/YYYY'
          )
          this.bloqueio.dataFim = moment(result.bloqueio.dataFim).format(
            'DD/MM/YYYY'
          )
          this.bloqueio.horarioInicio = result.bloqueio.horarioInicio
          this.bloqueio.horarioFim = result.bloqueio.horarioFim
          this.bloqueio.motivo = result.bloqueio.motivo
          this.bloqueio.observacao = result.bloqueio.observacao
          this.bloqueio.ativo = result.bloqueio.ativo
          this.bloqueio.temHorario =
            this.bloqueio.horarioInicio !== '00:01' &&
            this.bloqueio.horarioFim !== '23:59'
          this.bloqueio.regra =
            this.bloqueio.dataInicio === this.bloqueio.dataFim ? '1' : '2'
        })
      }
    },
    salvar() {
      this.v$.$touch()

      if (this.v$.bloqueio.$invalid) {
        mensagemServico.cadastroInvalido(this.v$)
      } else {
        if (!this.bloqueio.dataFim) {
          this.bloqueio.dataFim = this.bloqueio.dataInicio
        }

        const dataIni = this.bloqueio.dataInicio
        const dataFim = this.bloqueio.dataFim

        const dados = {
          ...this.bloqueio,
          dataInicio: moment(dataIni, 'DD/MM/YYYY').toISOString(),
          dataFim: moment(dataFim, 'DD/MM/YYYY').toISOString(),
        }

        if (dados._id) {
          profissionalBloqueioServico
            .atualizar(dados._id, dados)
            .then((result) => {
              if (result.erro) {
                mensagemServico.alerta(result.erro.content, result.erro.title)
                return
              }

              router.replace({ name: 'ProfissionalBloqueio' })
            })
        } else {
          profissionalBloqueioServico.criar(dados).then((result) => {
            if (result.erro) {
              mensagemServico.alerta(result.erro.content, result.erro.title)
              return
            }

            router.replace({ name: 'ProfissionalBloqueio' })
          })
        }
      }
    },
  },
}
</script>
